// extracted by mini-css-extract-plugin
export default {"container":"customLoading_container__Mo9en"};